import sortBy from 'lodash/sortBy'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import QuestionConfig from 'modules/reviews/store/models/QuestionConfig'

class QuestionConfigs extends Collection<QuestionConfig> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      sortByPosition: computed,
    })
  }

  model() {
    return QuestionConfig
  }

  get sortByPosition(): QuestionConfig[] {
    return sortBy(this.models, (questionConfig) => questionConfig.get('position'))
  }
}

// get questionConfigs(): QuestionConfig[] {
//   const questionGroupConfigIds = this.questionGroupConfigs.map((qgc) => qgc.attributes.id)

//   return questionConfigs.models.filter((qc) => {
//     if (!qc.has('id')) return false

//     return questionGroupConfigIds.includes(qc.attributes.surveys_question_group_config_id)
//   })
// }

// get activeQuestionConfigs(): QuestionConfig[] {
//   return this.questionConfigs.filter((qc) => !qc.isArchived)
// }

export default new QuestionConfigs()
